import React from 'react';
import { motion } from 'framer-motion';
import useT from '../../../i18n';

/**
 * Final CTA — centered end-of-page. Matches hero CTA styling for symmetry.
 */
export default function FinalCTA({ onPrimary, onLogin }) {
  const t = useT();
  const s = t.landingV2.finalCta;

  return (
    <section
      className="bg-paper py-section border-t border-ink/[0.06]"
      data-testid="landing-final-cta"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2 className="font-display font-light text-display-lg text-ink">
            {s.title}
          </h2>
          <p className="mt-6 font-sans text-lg text-ink/70 max-w-prose-wide mx-auto leading-relaxed">
            {s.subCopy}
          </p>

          <div className="mt-12 flex flex-col items-center gap-6">
            <button
              onClick={onPrimary}
              className="inline-flex items-center gap-2 bg-ink text-paper px-8 py-4 rounded-full font-sans text-sm font-medium hover:bg-ink/90 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-fjord/40 focus-visible:ring-offset-2 focus-visible:ring-offset-paper"
              data-testid="final-cta-primary"
            >
              {s.ctaPrimary}
            </button>
            <p className="font-sans text-sm text-ink/60">
              {s.loginPrompt}{' '}
              <button
                onClick={onLogin}
                className="text-ink/80 hover:text-ink underline underline-offset-4 decoration-ink/20 hover:decoration-ink/40 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-fjord/40 focus-visible:ring-offset-4 focus-visible:ring-offset-paper rounded-sm"
                data-testid="final-cta-login-link"
              >
                {s.loginLink} <span aria-hidden>→</span>
              </button>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
